import React, { useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Slide1 from '../../../../assets/images/Slide1.png';
import Slide2 from '../../../../assets/images/Slide2.png'
import Slide3 from '../../../../assets/images/Slide3.png'
import Slide4 from '../../../../assets/images/Slide4.png'
import Slide5 from '../../../../assets/images/Slide5.png'
import Slide6 from '../../../../assets/images/Slide6.png'
import Slide7 from '../../../../assets/images/Slide7.png'
import Slide8 from '../../../../assets/images/Slide8.png'
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

const Choose = () => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className="choose-zowo-container-zowo"
      onMouseEnter={() => setIsHovered(true)}
    >
     <Swiper navigation={true} modules={[Navigation]} className="swiper-investor">
      <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide1} alt="Slide 1" />
      </SwiperSlide>
      <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide2} alt="Slide 1" />
      </SwiperSlide>
      <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide3} alt="Slide 1" />
      </SwiperSlide>
      <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide4} alt="Slide 1" />
      </SwiperSlide>
      <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide5} alt="Slide 1" />
      </SwiperSlide>
      <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide6} alt="Slide 1" />
      </SwiperSlide>
       <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide7} alt="Slide 1" />
      </SwiperSlide>
       <SwiperSlide className="swiper-investor-slide">
        <img style={{ height: 100, width: 100,objectFit:'cover' }} src={Slide8} alt="Slide 1" />
      </SwiperSlide>
    </Swiper>
    </div>
  );
};
export default Choose;
